import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../const/endpoints';
const queryFnFactory = (config, keyProps, headers = {}) => {
    const fetchWrapper = getFetchWrapper(config);
    return () => {
        const params = new URLSearchParams({
            creditType: keyProps.creditType,
            membershipNumber: keyProps.membershipNumber,
            productType: keyProps.productType
        });
        return fetchWrapper(`${ENDPOINTS.authorizedBuyersLookup}?${params}`, {
            method: 'GET',
            headers: {
                ...headers
            }
        });
    };
};
export default queryFnFactory;
